import React, { useEffect, useState } from "react";
import {
  Box,
  Heading,
  Image,
  SimpleGrid,
  Stack,
  VStack
} from "@chakra-ui/react";

import DefaultAvatarImage from "assets/default-avatar.svg";
import ProfileText, { Variant } from "components/ProfileText";
import { format } from "date-fns";
import { Organization } from "types/organization";

interface Props {
  organization: Organization;
}

const OrganizationCard: React.FC<Props> = ({ organization }: Props) => {
  const [userCount, setUserCount] = useState(0);

  useEffect(() => {
    setUserCount(organization.users?.length || 0);
  }, []);

  return (
    <Box
      borderRadius="xl"
      width="100%"
      p={8}
      bg="gray.800"
      boxShadow="0px 4px 7px -1px rgba(0, 0, 0, 0.25)"
    >
      <Stack
        direction={["column", "row"]}
        spacing={[10, 20]}
        alignItems="center"
      >
        <Image
          bg="gray.700"
          borderRadius="2xl"
          boxSize="132px"
          src={""} // User's avatar image URL
          fallbackSrc={DefaultAvatarImage}
          alt={`${organization.name} profile image`}
          boxShadow="0px 4px 7px -1px rgba(0, 0, 0, 0.25)"
        />
        <VStack spacing={4} alignItems="flex-start">
          <Heading as="h2" p={0}>
            {organization.displayName}
          </Heading>
          <SimpleGrid columns={[1, 2]} gap={10}>
            <ProfileText
              label="Current Users"
              text={userCount.toString()}
              variant={Variant.LARGE}
            />
            <ProfileText
              label="Active Since"
              text={
                organization?.createdAt
                  ? format(new Date(organization.createdAt), "MMM y")
                  : ""
              }
              variant={Variant.LARGE}
            />
          </SimpleGrid>
        </VStack>
      </Stack>
    </Box>
  );
};

export default OrganizationCard;
